export default {
  loggedIn: {
    deposit: '입금',
    withdraw: '출금',
    balance: '총 잔액',
    cash: '현금',
    bonus: '보너스',
    withdrawable: '출금 가능',
    transaction: '거래 내역',
    history: '기록',
    myBet: 'My Bet',
    rollover: '롤오버',
    vault: '금고',
    notification: '알림',
    affiliate: '제휴 - 월 $5,000 수익',
    affiliateTitle: '제휴',
    affiliateBadge: '월 $5,000 수익',
    settings: '설정',
    currency: '통화',
    language: '언어',
    liveSupport: '실시간 지원',
    signOut: '로그아웃'
  }
};
